import { FeatureFlagsEnum } from '@omnea-app/packages/universal/hasura/graphql'

/**
 * P2P_ADMIN_MODE (frontend-only HubSpot stop-gap).
 *
 * Settings routes that an admin WITHOUT config permission may access when P2P_ADMIN_MODE
 * is enabled for their org. Deliberately a hardcoded allowlist: all of the stop-gap's
 * "which pages are relaxed" logic lives here so it is trivial to delete in the Q4
 * permissions re-architecture. Do not extend this list to grant broader config access.
 */
const P2P_ADMIN_MODE_RELAXED_ROUTES = ['workflows', 'forms'] as const

type FeatureFlagState = Partial<Record<FeatureFlagsEnum, boolean>>

/**
 * Whether a user satisfies the `hasConfigPermissions` requirement for a given settings route.
 *
 * Normally this is just `user.hasConfigPermissions` (Super Admin). Under P2P_ADMIN_MODE,
 * a plain admin additionally passes for the relaxed routes (workflows, forms).
 */
export const hasConfigPageAccess = ({
  hasConfigPermissions,
  route,
  featureFlags,
}: {
  hasConfigPermissions: boolean
  route: string | undefined
  featureFlags: FeatureFlagState
}): boolean => {
  if (hasConfigPermissions) {
    return true
  }
  return (
    !!featureFlags[FeatureFlagsEnum.P2P_ADMIN_MODE] &&
    route != null &&
    (P2P_ADMIN_MODE_RELAXED_ROUTES as readonly string[]).includes(route)
  )
}
